import React from 'react'

const CalenderArrowPrev = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none">
            <path d="M0.500195 8.2998L6.2002 13.8998C6.6002 14.2998 7.2002 14.2998 7.6002 13.8998C8.0002 13.4998 8.0002 12.8998 7.6002 12.4998L2.7002 7.4998L7.6002 2.4998C8.0002 2.0998 8.0002 1.4998 7.6002 1.0998C7.4002 0.899804 7.2002 0.799805 6.9002 0.799805C6.60019 0.799805 6.4002 0.899804 6.2002 1.0998L0.500195 6.6998C0.100195 7.1998 0.100195 7.7998 0.500195 8.2998C0.500195 8.1998 0.500195 8.1998 0.500195 8.2998Z" fill="#797B86" />
        </svg>
    )
}

export default CalenderArrowPrev